// extracted by mini-css-extract-plugin
export default {"content-container":"slider--1xf1Y","content-container--centerAlign":"slider--2NSdt","content-container--light":"slider--fgiGn","slide-content":"slider--2I7Ap"};